var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinesBankAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#101820;stroke-linecap:square;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1.134)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17,1,1,9.533V13.8H33V9.533Z",
    transform: "translate(-1 -1)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 8.533,
    transform: "translate(3.2 16)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 8.533,
    transform: "translate(11.733 16)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 8.533,
    transform: "translate(20.267 16)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 8.533,
    transform: "translate(28.8 16)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.133,
    cy: 2.133,
    r: 2.133,
    transform: "translate(13.867 5.333)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 4.267,
    transform: "translate(0 27.733)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinesBankAccount);
export default __webpack_public_path__ + "static/media/Icon_Lines_Bank-account.8258f58a09ec9a54412dc39996e1ac54.svg";
export { ForwardRef as ReactComponent };